'use client';

import {
  TextFieldRoot,
  type TextFieldProps,
  type TextFieldBaseProps,
  textFieldClasses,
} from './TextField';
import {
  TextFieldActionClear,
  type TextFieldActionClearProps,
  type TextFieldActionClearBaseProps,
  textFieldActionClearClasses,
} from './TextFieldActionClear';
import {
  TextFieldActionView,
  type TextFieldActionViewProps,
  type TextFieldActionViewBaseProps,
  textFieldActionViewClasses,
} from './TextFieldActionView';
import {
  TextFieldSlot,
  type TextFieldSlotProps,
  type TextFieldSlotBaseProps,
  textFieldSlotClasses,
} from './TextFieldSlot';

const TextField = Object.assign(TextFieldRoot, {
  Slot: TextFieldSlot,
  ActionClear: TextFieldActionClear,
  ActionView: TextFieldActionView,
});

export {
  TextField,
  type TextFieldProps,
  type TextFieldBaseProps,
  textFieldClasses,
  type TextFieldSlotProps,
  type TextFieldSlotBaseProps,
  textFieldSlotClasses,
  type TextFieldActionClearProps,
  type TextFieldActionClearBaseProps,
  textFieldActionClearClasses,
  type TextFieldActionViewProps,
  type TextFieldActionViewBaseProps,
  textFieldActionViewClasses,
};
